import { ROUTES } from "./constants";

/** Persisted across signup redirect so sign-in action can claim the shadow tenant. */
export const SHADOW_INVITE_LINK_STORAGE_KEY = "bomani.shadowInviteLink";

export type ShadowInviteLinkPayload = {
  shadowTenantId: string;
  leaseId: string;
};

export function readShadowInviteLinkFromStorage(): ShadowInviteLinkPayload | undefined {
  if (typeof sessionStorage === "undefined") return undefined;
  try {
    const raw = sessionStorage.getItem(SHADOW_INVITE_LINK_STORAGE_KEY);
    if (!raw?.trim()) return undefined;
    const parsed = JSON.parse(raw) as ShadowInviteLinkPayload;
    if (
      typeof parsed.shadowTenantId === "string" &&
      typeof parsed.leaseId === "string" &&
      parsed.shadowTenantId.trim() &&
      parsed.leaseId.trim()
    ) {
      return {
        shadowTenantId: parsed.shadowTenantId.trim(),
        leaseId: parsed.leaseId.trim(),
      };
    }
    return undefined;
  } catch {
    return undefined;
  }
}

export function writeShadowInviteLinkToStorage(payload: ShadowInviteLinkPayload): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(
      SHADOW_INVITE_LINK_STORAGE_KEY,
      JSON.stringify(payload)
    );
  } catch {
    /* ignore */
  }
}

export function clearShadowInviteLinkFromStorage(): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(SHADOW_INVITE_LINK_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * If a shadow invite is still pending (e.g. after signup redirect), resume verification at this URL.
 */
export function getShadowInviteResumeUrl(): string | null {
  const pending = readShadowInviteLinkFromStorage();
  if (!pending?.shadowTenantId || !pending?.leaseId) return null;
  return `${ROUTES.shadowInvite}?shadowTenantId=${encodeURIComponent(
    pending.shadowTenantId
  )}&leaseId=${encodeURIComponent(pending.leaseId)}`;
}
